import React, { useState } from 'react';
import './CourseDetailsContent.css';
import { FaAngleUp, FaAngleDown } from 'react-icons/fa';

const CourseDetailsContent = ({ courseData, handleEnroll }) => {
    const [expandedModules, setExpandedModules] = useState({});

    const toggleModule = (moduleId) => {
        setExpandedModules((prev) => ({
            ...prev,
            [moduleId]: !prev[moduleId],
        }));
    };

    const handleLessonSelect = (id, videoUrl, title) => {
        console.log(`Selected Lesson: ${title} - Video URL: ${videoUrl}`);
    };

    return (
        <div className="coursedetails-content-maincontainer">
            <h2 className="course-learnings-title">Course Content</h2>
            <div className="coursedetails-content-wrapper">
                {courseData && courseData.data && (
                    <div className="accordion-container">
                        {courseData.data.sections.map((module) => (
                            <div key={module.id} className="accordion-module">
                                 <div
                                    className={`accordion-header ${
                                        expandedModules[module.id] ? 'active' : ''
                                    }`}
                                    onClick={() => toggleModule(module.id)}
                                >
                                    <span>{module.title}</span>
                                    <span className="accordion-icon">
                                    {expandedModules[module.id] ? <FaAngleUp /> : <FaAngleDown />}
                                    </span>
                                </div>

                                 {expandedModules[module.id] && (
                                    <div className={`accordion-lessons ${
                                        expandedModules[module.id] ? 'active' : ''
                                    }`}>
                                        {module.lessons.map((lesson) => (
                                            <div
                                                key={lesson.id}
                                                className="lesson-item"
                                                onClick={() =>
                                                    handleLessonSelect(
                                                        lesson.id,
                                                        lesson.videoUrl,
                                                        lesson.title
                                                    )
                                                }
                                            >
                                                <span>{lesson.title}</span>
                                                <button
                                                    className="enroll-button"
                                                    onClick={handleEnroll}
                                                >
                                                    Start Now →
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CourseDetailsContent;
